'use client';

import ActionButton from '@/components/form/ActionButton/ActionButton';
import ModalBase from '@/components/ui/ModalBase/ModalBase';
import { useCurrentPathname } from '@/hooks/useCurrentPathname';
import { useGlobalLoadingAtom } from '@/state';
import useIsMovingToOtherPath from '@/utils/useIsMovingToOtherPath';
import { useRouter } from 'next/navigation';
import styles from './SignInPromptModal.module.scss';

function SignInPromptModal({
  isOpen,
  onClose,
  description,
}: {
  isOpen: boolean;
  onClose: () => void;
  description?: string;
}) {
  const router = useRouter();
  const isMovingToOtherPath = useIsMovingToOtherPath();
  const currentPathname = useCurrentPathname();
  const [_, startGlobalLoading] = useGlobalLoadingAtom();
  const goLogin = async () => {
    if (isMovingToOtherPath(currentPathname)) {
      startGlobalLoading();
    }
    router.push(`/auth/signin?callbackUrl=${encodeURIComponent(currentPathname)}`);
  };

  return (
    <ModalBase isOpen={isOpen} onClose={onClose} showBottomCloseButton={false}>
      <div className={styles.componentStyle}>
        <p className={styles.modalTitle}>ログインが必要です</p>
        <p className={styles.description}>{description}</p>
        <div className={styles.buttonContainer}>
          <ActionButton size='large' bgColor='red' color='white' onClick={goLogin}>
            ログイン
          </ActionButton>
          <ActionButton size='spCompact' bgColor='gray300' color='darkgray' onClick={onClose}>
            キャンセル
          </ActionButton>
        </div>
      </div>
    </ModalBase>
  );
}

export default SignInPromptModal;
